<template>
    <v-data-table :headers="colunas" :items="itens"
                  :hide-actions="itens.length < 10"
                  :custom-sort="ordenarPorSequenciaDeInteiros"
                  class="az-table-list"
                  no-data-text="Houve um erro ao carregar os itens"
                  :rows-per-page-items="[10, 25, 50]">

        <template slot="items" slot-scope="props">
            <td>
                {{ props.item.sequencia }}
            </td>
            <td ref="coluna_descricao">
                <expansao-texto :tamanho="tamanho" :texto="props.item.descricao"/>
            </td>
            <td align="right" class="red--text">
                <strong>{{ props.item.valor | azCurrency }}</strong>
            </td>
        </template>
    </v-data-table>
</template>
<script>
export default {
    name: 'TabelaReinserirValoresItens',
    props: {
        itens:{
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
    },
    data(){
        return{
            tamanho: null,
            colunas: [
                {
                    align: 'left',
                    sortable: true,
                    width: '10%',
                    class: 'primary--text',
                    text: 'Seq',
                    value: 'sequencia'
                },
                {
                    align: 'left',
                    value: 'descricao',
                    class: 'primary--text',
                    text: 'Descrição',
                    width: '45%',
                    sortable: false
                },
                {
                    sortable: false,
                    text: 'Valor Total',
                    align: 'right',
                    width: '20%',
                    value: 'valorTotal',
                    class: 'primary--text'
                },
            ],
        }
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    methods:{
        pegarTamanho() {
            this.tamanho = .082 * window.innerWidth
        },
        atualizarValor(novoValor, item) {
            item.valorDigitado = novoValor
        },
    }
}
</script>
